export default __webpack_public_path__ + "static/related-dont-5022ccb19470209619762a690721ec6c.png";